// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"4781f8b2","392":"ce9e0c5a","563":"d21b868f","598":"191e6b29","835":"cce9adc8"}[chunkId] + ".chunk.css";
};